/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import keyBy from 'lodash/fp/keyBy.js';
import {
  STRUCTURAL_RESPONSES,
  STRUCTURAL_RESPONSE_EDP_KEY,
  STRUCTURAL_RESPONSE_ITEM_KEY,
  STRUCTURAL_RESPONSE_NAME,
  STRUCTURAL_RESPONSE_UPLOAD,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { EDP_IDR, edpsByKey } from '@hbrisk/sp3-risk-model-support/edps/edps.js';
import { structuralResponseMethodOptions } from '@hbrisk/sp3-risk-model-support/models/form/fieldOptions.js';
import {
  selectIsStructuralResponseMethodMatch,
  selectStructuralResponseIsSuccessByKey,
} from '#selectors/entities/models.js';
import ResponseDetail from './ResponseDetail.jsx';
import { modelTypesByForm } from '#constants/models/modelTypes/index.js';

const mapStateToProps = (state, ownProps) => {
  const { modelId, method, form, field, responseItemKey, edpKey } = ownProps;
  const {
    selectFormFieldVisibility,
    selectFormValues,
    fields: modelFields,
  } = modelTypesByForm[form];

  // Build itemSchemaFieldsByName from the STRUCTURAL_RESPONSES FieldArray's itemSchema
  const srFieldDef = modelFields.find(f => f.name === STRUCTURAL_RESPONSES);
  const itemSchemaFieldsByName = keyBy('name', srFieldDef.itemSchema);

  // Compute method options filtered by the EDP's excluded methods
  const edp = edpsByKey[edpKey];
  const methodOptions = structuralResponseMethodOptions.filter(
    opt => !(edp.excludedMethods || []).includes(opt.value)
  );

  // Compute IDR response options for the DerivedFrom select
  const responses = selectFormValues(state, STRUCTURAL_RESPONSES);
  const idrResponseOptions = (responses || [])
    .filter(r => r[STRUCTURAL_RESPONSE_EDP_KEY] === EDP_IDR)
    .map(r => ({
      value: r[STRUCTURAL_RESPONSE_ITEM_KEY],
      text: r[STRUCTURAL_RESPONSE_NAME] || r[STRUCTURAL_RESPONSE_ITEM_KEY],
    }));

  const isMatch = selectIsStructuralResponseMethodMatch(state, {
    modelId,
    responseItemKey,
    method,
  });
  const isSuccess = selectStructuralResponseIsSuccessByKey(state, { modelId, responseItemKey });

  const showResponse = isMatch && isSuccess;
  const showUploader = selectFormFieldVisibility(state)(`${field}.${STRUCTURAL_RESPONSE_UPLOAD}`);

  return {
    itemSchemaFieldsByName,
    methodOptions,
    idrResponseOptions,
    showResponse,
    showUploader,
  };
};

export default connect(mapStateToProps)(ResponseDetail);
